// extracted by mini-css-extract-plugin
export var container = "_af-1";
export var cornerButtonContainer = "_af-5";
export var disabled = "_af-2";
export var fileContainer = "_af-4";
export var hiddenInput = "_af-3";
export var widthContainer = "_af-0";